<template>
  <div
    class="main w-full px-4 sm:px-10 md:px-20 lg:px-40 xl:px-40 2xl:px-80 pt-10"
  >
    <!-- Section 1: About FutureRent -->
    <section class="w-full flex flex-col gap-10 mb-20">
      <h1
        class="text-2xl header-text sm:text-3xl md:text-4xl w-full text-left lg:text-center mb-2"
      >
        About FutureRent
      </h1>

      <!-- Image (full width) -->
      <div class="image-container w-full team-image"></div>

      <!-- Text (full width) -->
      <div class="w-full flex flex-col gap-6">
        <p class="text-base sm:text-lg">
          FutureRent is a car subscription platform based in Cape Town, South
          Africa.
        </p>
        <p class="text-base sm:text-lg">
          Founded in 2022 by Luke Henwood, it offers a flexible alternative to
          traditional car ownership, with vehicles available on subscription
          terms that include insurance, warranty, servicing, tracking and
          roadside assistance — all in a single monthly fee.
        </p>
        <p class="text-base sm:text-lg">
          "Why should drivers be stuck with long-term car loans that outlast the
          appeal and reliability of the vehicles they finance?" This question
          inspired FutureRent and defines our approach to mobility. Founded in
          Cape Town in 2022 by Luke Henwood, FutureRent is about shifting from
          debt-driven ownership to flexible, all-inclusive vehicle access. We
          offer monthly subscriptions that bundle insurance, roadside
          assistance, servicing and tracking in one transparent fee. No hidden
          costs. No surprises. Mobility should create freedom, not financial
          strain. Our platform gives individuals and entrepreneurs the
          confidence to move forward, whether they're starting fresh, scaling
          up, or simply refusing to be tied down. We're here to deliver
          something better.
        </p>
      </div>
    </section>

    <!-- Section 2: Funding Round -->
    <section class="w-full flex flex-col gap-10 mb-20">
      <!-- Image (full width) -->
      <div class="image-container w-full building-image"></div>

      <!-- Text (full width) -->
      <div class="w-full flex flex-col gap-6">
        <p class="text-base sm:text-lg">
          FutureRent, South Africa's pioneering car subscription company, has
          secured R100 million (circa. €5 Million) in its first funding round,
          backed by a German family office.
        </p>
        <p class="text-base sm:text-lg">
          The capital injection marks a major step forward in FutureRent's
          mission to reinvent mobility through flexible, finance-free vehicle
          access.
        </p>
        <p class="text-base sm:text-lg">
          FutureRent Raises R100 Million (€5 Million) in First Funding Round,
          Adds 450 Vehicles to Fleet Image caption: The FutureRent team with
          Luke Henwood, Chief Executive Officer, in the centre. FutureRent,
          South Africa's pioneering car subscription company, has secured R100
          million (circa. €5 Million) in its first funding round, backed by a
          German family office. The capital injection marks a major step forward
          in FutureRent's mission to reinvent mobility through flexible,
          finance-free vehicle access. The deal brings over 450 new vehicles to
          FutureRent's growing fleet, the company's most significant expansion
          to date. This scale-up will allow FutureRent to meet rising demand
          across the Western Cape, while continuing to make vehicle access
          faster, simpler and more affordable.
        </p>
      </div>
    </section>
  </div>
</template>

<style scoped>
.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%; /* always full width now */
  height: 58rem; /* default desktop height */
}

@media (max-width: 640px) {
  .image-container {
    height: 15rem !important; /* smaller height for mobile */
  }
  .text {
    margin-top: -1rem !important;
  }
  .first-text {
    margin-top: -1rem !important;
  }
  .mobile {
    margin-bottom: 1rem;
  }
}

.team-image {
  background-image: url("@/assets/images/team.jpg");
}

.building-image {
  background-image: url("@/assets/images/building.jpg");
}

.text {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  font-size: 2rem;
}

@media (min-width: 1024px) and (max-width: 1440px) {
  .text {
    gap: 1.5rem;
  }

  .image-container {
    height: 33rem !important; /* larger image height on medium-large screens */
  }

  .header-text {
    font-size: 2.3rem;
  }
}

@media (min-width: 1441px) {
  .header-text {
    font-size: 2.3rem;
  }
}
</style>
